<template lang="pug">
.card
  .card-body.flex-centered.flex-column
    .d-flex.justify-content-around
      .logo-container.my-2
        img.app-logo.img-responsive(alt="App logo", src="@/assets/logo.png")
    .h3.mt-2 Acesso Cidadão
    .version v{{ version }}
    .text.pt-2.text-center O Acesso Cidadão tem como principal objetivo facilitar a vida do cidadão, oferecendo serviços que podem ser acessados a qualquer momento de maneira fácil e rápida, prezando sempre pela transparência e confiabilidade.
  .mobile-app.flex-centered.flex-column
    img.img-responsive.image-qr.my-2(
      alt="Qr code para baixar o aplicativo",
      src="@/assets/qr-code.png"
    )
    .flex-centered
      a.mx-2.c-hand.tooltip(
        data-tooltip="Google Play",
        href="https://play.google.com/store/apps/details?id=com.paliari.cidadaomga",
        target="_blank"
      )
        img(src="@/assets/google-play.png")
      a.mx-2.c-hand.tooltip(
        data-tooltip="App Store",
        href="https://apps.apple.com/br/app/cidadao-maringa/id932510005",
        target="_blank"
      )
        img(src="@/assets/app-store.png")
    .text-small.text-center Baixe agora mesmo
    .text.text-center Disponível também para Android e iOS
  .card-footer
    .divider
    a.no-decoration.d-flex.align-items-center.text-left.m-2.tooltip(
      href="https://paliari.com.br",
      target="_blank",
      data-tooltip="Visitar"
    )
      .logo-container
        img.paliari-logo.img-responsive(
          alt="Paliari logo",
          src="@/assets/logo-paliari.png"
        )
      .pl-2
        .text-small Desenvolvido por
        div Paliari Engenharia de Software
</template>

<script>
export default {
  computed: {
    version() {
      return require("../../package").version;
    },
  },
};
</script>

<style lang="stylus" scoped>
a {
  box-shadow: none;
}

.divider {
  width: 100%;
  border-color: rgba(255, 255, 255, 0.1);
}

.d-flex.justify-content-around {
  width: 50%;
  flex-wrap: wrap;
}

.logo-container {
  background-color: white;
  border-radius: 50%;
  padding: 10px;
  display: inline-block;
}

.version {
  font-size: 0.7rem;
}

.app-logo {
  max-width: 100px;
}

.paliari-logo {
  max-width: 50px;
}

.card {
  overflow-y: auto;

  .card-body {
    padding: 0 2rem;
  }

  .image-qr {
    width: 150px;
  }

  .card-footer {
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    flex-wrap: wrap;
  }
}
</style>
